import type { Clerk } from "@clerk/nextjs/types";
import { NativeClerk, configureNativeClerk } from "@/lib/client/nativeClerk";
import { isNativeCapacitorApp } from "@/lib/client/capacitor";

const NATIVE_SESSION_ENDPOINT = "/api/native-session";

export const syncNativeClerkSession = async (clerk: Clerk) => {
  if (!isNativeCapacitorApp()) {
    return false;
  }

  await configureNativeClerk();

  const nativeState = await NativeClerk.isSignedIn();

  if (!nativeState.isSignedIn) {
    return false;
  }

  const { token } = await NativeClerk.getToken();

  if (!token) {
    return false;
  }

  const response = await fetch(NATIVE_SESSION_ENDPOINT, {
    method: "POST",
    credentials: "include",
    cache: "no-store",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Unable to synchronize the native Clerk session");
  }

  const { ticket } = (await response.json()) as { ticket?: string };

  if (!ticket || !clerk.client?.signIn) {
    throw new Error("Native Clerk session synchronization returned no ticket");
  }

  const signIn = await clerk.client.signIn.create({ strategy: "ticket", ticket });

  if (signIn.status !== "complete" || !signIn.createdSessionId) {
    throw new Error("Native Clerk session ticket did not create a session");
  }

  await clerk.setActive({ session: signIn.createdSessionId });
  return true;
};
